import React from 'react';
import { legalInfo } from '../utils/legal';

const TermsOfSale: React.FC = () => {
  const name = legalInfo.tradingName || legalInfo.legalName;
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-left">
      <h1 className="text-3xl font-bold mb-4">Terms of Sale</h1>
      <p className="text-gray-700 mb-6">Last updated: {new Date().getFullYear()}</p>
      <p className="mb-4">These terms apply to orders you place with {name}.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Orders and payment</h2>
      <p className="mb-4">Orders are accepted when we confirm them. Payments are processed securely by our payment provider; we do not store full card details.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Allergens</h2>
      <p className="mb-4">Please inform us of allergies. We handle allergens in our kitchen; cross-contamination is possible.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Collection and delivery</h2>
      <p className="mb-4">Estimated times are guides only. We will notify you if there are material delays.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Cancellations and refunds</h2>
      <p className="mb-4">If there is an issue with your order, please contact us promptly so we can put it right. Your statutory rights are not affected.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
      <p>Email: {legalInfo.publicEmail || 'add email'} | Phone: {legalInfo.publicPhone || 'add phone'}</p>
    </div>
  );
};

export default TermsOfSale;





